namespace TabAurous.ECommerce {
    export interface ECommExchangeTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        CessId?: number;
        CessRate?: number;
        CessAmount?: number;
        TaxType?: string;
        TaxName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        TaxLedgerId?: number;
        CessLedgerId?: number;
    }

    export namespace ECommExchangeTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'ECommerce.ECommExchangeTax';
        export const deletePermission = 'EComm:ECommExchange:Delete';
        export const insertPermission = 'EComm:ECommExchange:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommExchange:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            CessId = "CessId",
            CessRate = "CessRate",
            CessAmount = "CessAmount",
            TaxType = "TaxType",
            TaxName = "TaxName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            TaxLedgerId = "TaxLedgerId",
            CessLedgerId = "CessLedgerId"
        }
    }
}
